import { ref } from 'vue';
import axios from 'axios';

export default function useApplicationLogs(notifyResult) {
  const logs = ref([]);
  const filteredLogs = ref([]);
  const loading = ref(false);

  const fetchLogs = async (applicationId) => {
    if (!applicationId) return;

    try {
      loading.value = true;
      const url = `${process.env.VUE_APP_HOUSING_SERVICE_URL}/api/AuditLogs/application/${applicationId}`;

      const response = await axios.get(url);

      if (response.status === 200 && response.data && response.data.data) {
        logs.value = response.data.data;
        filteredLogs.value = [...logs.value];
      } else {
        logs.value = [];
        filteredLogs.value = [];
        notifyResult(response.status, response);
      }
    } catch (error) {
      console.error('Error fetching application logs:', error);
      logs.value = [];
      filteredLogs.value = [];
      notifyResult(error.response ? error.response.status : 500, error.response || error);
    } finally {
      loading.value = false;
    }
  };

  return {
    logs,
    filteredLogs,
    loading,
    fetchLogs,
  };
}
